import {
  AddCircleOutline,
  Done,
  RemoveCircle,
} from "@mui/icons-material";
import {
  Avatar,
  Box,
  Button,
  Collapse,
  Divider,
  Grid2,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { commonCss } from "../../../CssStyle/commonCss";
import Lottie from "lottie-react";
import { useNavigate } from "react-router-dom";
import lottieImage from "../../../Images/Outsourcing/augment.json";
// import aboutUsBg from "../../../Images/aboutUsBg.jpg";
// import react from "../../../Images/Outsourcing/Icon/react.png";
// import angular from "../../../Images/Outsourcing/Icon/angular.png";
// import javascript from "../../../Images/Outsourcing/Icon/javascript.png";
// import php from "../../../Images/Outsourcing/Icon/php.png";
// import python from "../../../Images/Outsourcing/Icon/python.png";
// import html from "../../../Images/Outsourcing/Icon/html.png";
// import css from "../../../Images/Outsourcing/Icon/css.png";
// import wordpress from "../../../Images/Outsourcing/Icon/wordpress.png";
// import avatar from "../../../Images/Outsourcing/expertImage.png";
// import flowchart from "../../../Images/Outsourcing/flowchart.png";
import AutoSlider from "./AutoSlider";

const Outsourcing = () => {
  const navigate = useNavigate();
  const [hire, setHire] = useState({
    aws: false,
    fullStackDev1: false,
    fullStackDev2: false,
    fullStackDev3: false,
    fullStackDev4: false,
    SE: false,
    QE: false,
    STE: false,
    SrUIDesigner: false,
    UIDesigner: false,
  });
  const [question, setQuestion] = useState({
    question1: false,
    question2: false,
    question3: false,
    question4: false,
    question5: false,
    question6: false,
    question7: false,
    question8: false,
    question9: false,
    question10: false,
  });

  const listRole = [
    "Frontend Developer",
    "UI/UX Designers",
    "Backend Developers",
    "QA Engineers",
    "App Developers",
  ];
  const icon = ["/Images/Outsourcing/Icon/react.png", "/Images/Outsourcing/Icon/angular.png", "/Images/Outsourcing/Icon/php.png", "/Images/Outsourcing/Icon/javascript.png", "/Images/Outsourcing/Icon/python.png", "/Images/Outsourcing/Icon/html.png", "/Images/Outsourcing/Icon/css.png", "/Images/Outsourcing/Icon/wordpress.png"];
  const hireList = [
    {
      name: "Sr. AWS Engineer",
      expertList: [
        {
          title: "AWS",
          bg: commonCss.expertColor1,
        },
        {
          title: "GCP",
          bg: commonCss.expertColor2,
        },
        {
          title: "Azure",
          bg: commonCss.expertColor3,
        },
        {
          title: "DevOps",
          bg: "white",
        },
        {
          title: "Linux",
          bg: commonCss.expertColor4,
        },
      ],
      state: "aws",
      experience: "10 yrs",
    },
    {
      name: "Full Stack Developer",
      expertList: [
        {
          title: "NodeJS",
          bg: commonCss.expertColor1,
        },
        {
          title: "ExpressJS",
          bg: commonCss.expertColor2,
        },
        {
          title: "Laravel 5",
          bg: commonCss.expertColor3,
        },
        {
          title: "Angular",
          bg: "white",
        },
        {
          title: "mySql",
          bg: commonCss.expertColor4,
        },
      ],
      state: "fullStackDev1",
      experience: "4.5 yrs",
    },
    {
      name: "Full Stack Developer",
      expertList: [
        {
          title: "PHP",
          bg: commonCss.expertColor1,
        },
        {
          title: "JQuery",
          bg: commonCss.expertColor2,
        },
        {
          title: "Bootstrap",
          bg: commonCss.expertColor3,
        },
        {
          title: "React",
          bg: "white",
        },
        {
          title: "RestfullAPI",
          bg: commonCss.expertColor4,
        },
      ],
      state: "fullStackDev2",
      experience: "4.5 yrs",
    },
    {
      name: "Full Stack Developer",
      expertList: [
        {
          title: "Angular",
          bg: commonCss.expertColor1,
        },
        {
          title: "Iconic",
          bg: commonCss.expertColor2,
        },
        {
          title: "Capacitor",
          bg: commonCss.expertColor3,
        },
        {
          title: "Cordava",
          bg: "white",
        },
        {
          title: "Flutter",
          bg: commonCss.expertColor4,
        },
      ],
      state: "fullStackDev3",
      experience: "4 yrs",
    },
    {
      name: "Full Stack Developer",
      expertList: [
        {
          title: "Angular",
          bg: commonCss.expertColor1,
        },
        {
          title: "Iconic",
          bg: commonCss.expertColor2,
        },
        {
          title: "JavaScript",
          bg: commonCss.expertColor3,
        },
        {
          title: "TypeScript",
          bg: "white",
        },
        {
          title: "NodeJS",
          bg: commonCss.expertColor4,
        },
      ],
      state: "fullStackDev4",
      experience: "4 yrs",
    },
    {
      name: "Sr. QA Engineer",
      expertList: [
        {
          title: "Jira",
          bg: commonCss.expertColor1,
        },
        {
          title: "Manual",
          bg: commonCss.expertColor2,
        },
        {
          title: "Automation",
          bg: commonCss.expertColor3,
        },
        {
          title: "Web & App",
          bg: "white",
        },
        {
          title: "Selenium",
          bg: commonCss.expertColor4,
        },
      ],
      state: "QE",
      experience: "9 yrs",
    },
    {
      name: "Software Test Engineer",
      expertList: [
        {
          title: "Jira",
          bg: commonCss.expertColor1,
        },
        {
          title: "Manual",
          bg: commonCss.expertColor2,
        },
        {
          title: "Automation",
          bg: commonCss.expertColor3,
        },
        {
          title: "Web & App",
          bg: "white",
        },
        {
          title: "Selenium",
          bg: commonCss.expertColor4,
        },
      ],
      state: "STE",
      experience: "9 yrs",
    },
    {
      name: "Sr. Software Engineer",
      expertList: [
        {
          title: "Angular",
          bg: commonCss.expertColor1,
        },
        {
          title: "Iconic",
          bg: commonCss.expertColor2,
        },
        {
          title: "NodeJS",
          bg: commonCss.expertColor3,
        },
        {
          title: "PHP",
          bg: "white",
        },
        {
          title: "JSON",
          bg: commonCss.expertColor4,
        },
        {
          title: "Firebase",
          bg: commonCss.expertColor5,
        },
      ],
      state: "SE",
      experience: "4 yrs",
    },
    {
      name: "Sr. UI/UX Designer",
      expertList: [
        {
          title: "HTML",
          bg: commonCss.expertColor2,
        },
        {
          title: "CSS",
          bg: commonCss.expertColor3,
        },
        {
          title: "JS",
          bg: "white",
        },
        {
          title: "Figma",
          bg: commonCss.expertColor4,
        },
        {
          title: "Wordpress",
          bg: commonCss.expertColor5,
        },
      ],
      state: "SrUIDesigner",
      experience: "2 yrs",
    },
    {
      name: "UI/UX Designer",
      expertList: [
        {
          title: "HTML",
          bg: commonCss.expertColor2,
        },
        {
          title: "CSS",
          bg: commonCss.expertColor3,
        },
        {
          title: "JS",
          bg: "white",
        },
        {
          title: "Figma",
          bg: commonCss.expertColor4,
        },
        {
          title: "Illustrator",
          bg: commonCss.expertColor5,
        },
      ],
      state: "UIDesigner",
      experience: "2 yrs",
    },
  ];

  const questionList = [
    {
      questionName: "How does our process work?",
      answer:
        "We follow a meticulous 4-step vetting and onboarding process to ensure you’re matched with the right talent or team to bring your vision to life.",
      listOfAns: true,
      anslist: [
        {
          title: "Understand Your Needs",
          answer:
            " - We begin by diving deep into your project—understanding the objectives, goals, desired outcomes, and any specific requirements to ensure complete clarity.",
        },
        {
          title: "Share Curated Profiles",
          answer:
            " - We present you with carefully selected expert profiles that match your criteria, so you can review and shortlist candidates best suited for your needs.",
        },
        {
          title: "Evaluate and Interview",
          answer:
            " - We assist in a multi-stage assessment process, enabling you to interview and handpick the right talent with confidence.",
        },
        {
          title: "Seamless Onboarding",
          answer:
            " - Once selected, we facilitate a smooth onboarding experience—setting clear goals, integrating the talent into your workflow, and ensuring alignment from day one.",
        },
      ],
      state: "question1",
    },
    {
      questionName: "Why choose an offshore dedicated developer?",
      answer:
        "To access skilled, cost-effective talent who deliver high-quality, scalable solutions tailored to your needs—faster and more efficiently.",
      listOfAns: false,
      anslist: [],
      state: "question2",
    },
    {
      questionName:
        "How do I monitor and evaluate the performance of a hired developer?",
      answer:
        "We help you stay fully in control by following a structured performance monitoring protocol:",
      listOfAns: true,
      anslist: [
        {
          title: "Progress Tracking",
          answer:
            " - Get regular updates—daily or weekly—through project management tools, reports, and virtual stand-ups to ensure milestones and deadlines are being met.",
        },
        {
          title: "Communication Monitoring",
          answer:
            " - We assess responsiveness, collaboration, and clarity in communication to ensure smooth coordination with your team.",
        },
        {
          title: "Performance Metrics",
          answer:
            " - We track key indicators like productivity, code quality, bug resolution time, and deadline adherence to measure effectiveness and identify areas for improvement.",
        },
      ],
      state: "question3",
    },

    {
      questionName:
        "What if I'm not satisfied with the hired developer—can I request a replacement?",
      answer:
        "Yes, your satisfaction is our priority. While our developers are carefully vetted to deliver exceptional results, we understand that fit matters. If you're not fully satisfied, we offer a flexible replacement policy to match you with a developer better aligned to your needs.Should you decide to terminate the engagement, a 2-week notice is required. Any completed or in-progress work will be delivered in a usable electronic format, and the final invoice will reflect all work done up to the termination date.",
      listOfAns: false,
      anslist: [],
      state: "question4",
    },

    {
      questionName:
        "Does Solver Thoughts Technologies offer an NDA for project confidentiality?",
      answer:
        "Absolutely. We prioritize your privacy and data security. Before any project begins, both our team and the hired talent sign a Non-Disclosure Agreement (NDA) to ensure complete confidentiality. Your project details, ideas, and sensitive information remain fully protected throughout the engagement.	",
      listOfAns: false,
      anslist: [],
      state: "question5",
    },
    {
      questionName: "Can the hired developers work in my time zone?",
      answer:
        "Yes. Our developers can align their working hours with your time zone and schedule to ensure seamless collaboration and real-time communication, based on your project's needs and objectives.",
      listOfAns: false,
      anslist: [],
      state: "question6",
    },
    {
      questionName:
        "Do you offer support and maintenance after project completion?",
      answer:
        "Yes, we provide ongoing support and maintenance to ensure your solution remains up-to-date, secure, and bug-free. Our goal is to give you a smooth, hassle-free experience even after the project is delivered.",
      listOfAns: false,
      anslist: [],
      state: "question7",
    },
    {
      questionName:
        "What hiring options are available with Solver Thoughts Technologies?",
      answer: "We offer two flexible hiring options:",
      listOfAns: true,
      anslist: [
        {
          title: "Offshore Staff Augmentation",
          answer:
            " - We carefully vet and provide a single developer with the specific skills required for your project. ",
        },
        {
          title: "Offshore Team Augmentation",
          answer:
            " - We assemble and vet an entire team with the necessary skill set to meet your project’s needs.",
        },
      ],
      state: "question8",
    },

    {
      questionName: "Can I hire a resource for part-time?",
      answer:
        "Yes, we offer flexible hiring options to suit your needs. You can hire our qualified IT professionals on a part-time basis, as well as for full-time, contractual, or permanent engagements, depending on your project requirements.",
      listOfAns: false,
      anslist: [],
      state: "question9",
    },
    {
      questionName:
        "Can your team or talent help complete an unfinished project?",
      answer:
        "Absolutely! Our skilled professionals have experience across various domains and can seamlessly step in to complete any unfinished project, ensuring a smooth continuation and successful delivery.",
      listOfAns: false,
      anslist: [],
      state: "question10",
    },
  ];

  const handlePopoverOpen = (stateName) => {
    setHire({
      aws: false,
      fullStockDev1: false,
      fullStockDev2: false,
      fullStockDev3: false,
      fullStockDev4: false,
      SE: false,
      QE: false,
      STE: false,
      SrUIDesigner: false,
      UIDesigner: false,
      [stateName]: true,
    });
  };
  const handlePopoverClose = () => {
    setHire({
      aws: false,
      fullStockDev1: false,
      fullStockDev2: false,
      fullStockDev3: false,
      fullStockDev4: false,
      SE: false,
      QE: false,
      STE: false,
      SrUIDesigner: false,
      UIDesigner: false,
    });
  };
  const handleCollapseOpen = (stateName, open) => {
    setQuestion({
      question1: false,
      question2: false,
      question3: false,
      question4: false,
      question5: false,
      question6: false,
      question7: false,
      question8: false,
      question9: false,
      question10: false,
      [stateName]: open,
    });
  };
  // const handleCollapseClose = () => {
  //   setQuestion({
  //     question1:false,
  //     question2:false,
  //     question3:false,
  //     question4:false,
  //     question5:false,
  //     question6:false,
  //     question7:false,
  //     question8:false,
  //     question9:false,
  //     question10:false,
  //   });
  // };
  return (
    <Grid2
      container
      justifyContent={"center"}
      alignItems={"center"}
      size={{ xs: 12 }}
    >
      <Grid2
        container
        alignItems={"center"}
        justifyContent={"center"}
        size={12}
        sx={{ background: `url(/Images/aboutUsBg.jpg)`, backgroundSize: "cover" }}
      >
        <Grid2
          container
          alignItems={"center"}
          size={12}
          spacing={{ xs: "1rem", md: "3rem" }}
          sx={{
            p: { xs: "1.5rem", md: "3rem" },
            // mt: { xs: "40%", sm: "30%", md: "15%", lg: "13%", xl: "5%" },
            mt:"18vh",
            maxWidth: { xs: "auto", xl: "2000px" },
          }}
        >
          <Grid2 size={{ xs: 12, md: 6 }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "1.5rem", md: "2rem" },
                fontWeight: 700,
                textTransform: "uppercase",
                mb: "1rem",
                color: commonCss.blue,
              }}
            >
              Augmentation
            </Typography>
            <Typography
              variant="h5"
              sx={{
                fontSize: { xs: "1.5rem", md: "2rem" },
                fontWeight: 500,
                lineHeight: "normal",
                mb: "1rem",
              }}
            >
              Capability Augmentation
            </Typography>
            <Typography sx={{ fontSize: "1.5rem", mb: "1rem" }}>
              Elevate your project execution with top-tier IT talent, ready to
              integrate seamlessly with your existing team.
            </Typography>
            <Typography
              sx={{
                fontSize: "1.1rem",
                fontWeight: 700,
                fontFamily: "inherit",
                mt: 4,
              }}
            >
              Specialized Talent at Your Fingertips:
            </Typography>
            <List
              sx={{
                "& .MuiListItemText-primary": {
                  fontFamily: "Roboto, sans-serif",
                  fontSize: "1rem",
                  fontWeight: 600,
                  ml: 2,
                },
                //  '& .MuiListItemIcon-root':{
                //   width:"10%"
                //  },
                display: "flex",
                gap: "0.5rem",
                flexWrap: "wrap",
                width: "100%",
                mt: "1rem",
              }}
            >
              {listRole.map((listData, i) => (
                <ListItem
                  key={i}
                  sx={{ p: 0, width: { xs: "100%", md: "47%" } }}
                >
                  <ListItemIcon sx={{ minWidth: "0" }}>
                    <Done />
                  </ListItemIcon>
                  <ListItemText>{listData}</ListItemText>
                </ListItem>
              ))}
            </List>
            <Box
              sx={{
                display: "flex",
                gap: "1rem",
                flexDirection: { xs: "column", md: "row" },
                mt: "1rem",
              }}
            >
              <Button
                sx={{
                  backgroundColor: commonCss.buttonBg,
                  color: commonCss.buttonText,
                  padding: "0.5rem",
                  textTransform: "none",
                  width: { xs: "60%", md: "40%" },
                  fontWeight: 500,
                  fontSize: "0.95rem",
                  borderRadius: "30px",
                  ":hover": {
                    background: commonCss.blue,
                  },
                }}
                onClick={() => {
                  navigate("/contactus");
                }}
              >
                Expert Help Here
              </Button>
            </Box>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <Box sx={{ mt: "-4rem" }}>
              <Lottie animationData={lottieImage} loop={true} />
            </Box>
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2 container justifyContent={"center"} alignItems={"center"} size={12}>
        <Grid2
          container
          alignItems={"center"}
          size={12}
          spacing={{ xs: "1rem", md: "3rem" }}
          sx={{
            p: { xs: "1.5rem", md: "3rem" },
            maxWidth: { xs: "auto", xl: "2000px" },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              width: "100%",
              gap: "1rem",
              justifyContent: { xs: "flex-start", lg: "space-between" },
            }}
          >
            {icon.map((listIcon, i) => (
              <Box
                key={i}
                sx={{
                  p: "1rem 0.5rem",
                  textAlign: "center",
                  width: { xs: "47%", sm: "30%", md: "18%", lg: "10%" },
                  borderRadius: "10px",
                  border: "1px solid #d6d6d6",
                }}
              >
                <img
                  src={listIcon}
                  sx={{ width: { xs: "42px", md: "60px" } }}
                  alt={listIcon.split("/").pop().replace(".png", "")}
                />
              </Box>
            ))}
          </Box>
        </Grid2>
      </Grid2>
      <Grid2
        container
        justifyContent={"center"}
        size={12}
        sx={{ background: commonCss.backgroundGray, padding: "2rem" }}
      >
        <Grid2 size={12}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 550,
              textAlign: "center",
              mt: "1rem",
              mb: "0.5rem",
            }}
          >
            Partner Success Stories
          </Typography>
        </Grid2>
        <Grid2
          container
          size={12}
          sx={{ maxWidth: { xs: "auto", xl: "2000px" } }}
        >
          <AutoSlider />
        </Grid2>
      </Grid2>
      <Grid2
        container
        alignItems={"center"}
        justifyContent={"center"}
        size={12}
        sx={{ background: commonCss.blue }}
      >
        <Grid2
          container
          alignItems={"center"}
          size={12}
          spacing={{ xs: "1rem", md: "3rem" }}
          sx={{
            p: { xs: "1.5rem", md: "3rem" },
            maxWidth: { xs: "auto", xl: "2000px" },
          }}
        >
          <Grid2 size={{ xs: 12, md: 5 }}>
            <Typography
              variant="h3"
              sx={{ fontSize: { xs: "2rem", md: "3rem" }, color: "white" }}
            >
              Engage Dedicated Experts
            </Typography>
            <Divider
              sx={{
                borderWidth: 2,
                borderColor: "white",
                width: { xs: "100%", md: "75%" },
                mt: 2,
              }}
            />
          </Grid2>
          <Grid2 size={{ xs: 12, md: 7 }}>
            <Typography
              variant="body1"
              sx={{ fontSize: { xs: "1rem", md: "1.5rem" }, color: "white" }}
            >
              Build and scale your dream team with ease—connect with us today.
            </Typography>
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2 container justifyContent={"center"} alignItems={"center"} size={12}>
        <Grid2
          container
          alignItems={"center"}
          size={12}
          // spacing={{ xs: "1rem", md: "1rem" }}
          spacing={"0.5rem"}
          sx={{
            p: { xs: "1.5rem", md: "3rem" },
            maxWidth: { xs: "auto", xl: "2000px" },
          }}
        >
          <Grid2 size={12}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 550,
                textAlign: "center",
                mt: "1rem",
                mb: "0.5rem",
              }}
            >
              Build Faster with the Right People on Your Side
            </Typography>
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: "1.1rem",
                color: commonCss.gray,
                textAlign: "center",
                mb: "2rem",
              }}
            >
              Innovation thrives on teamwork and bold ideas.
            </Typography>
          </Grid2>
          {hireList.map((listData, i) => (
            <Grid2
              size={12}
              key={i}
              sx={{
                borderBottom: "2px solid #d6d6d6",
                padding: "1rem",
                cursor: "pointer",
              }}
              onMouseEnter={() => {
                handlePopoverOpen(listData.state);
              }}
              onMouseLeave={() => {
                handlePopoverClose(listData.state);
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                  gap: { xs: "1rem", md: "0rem" },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    gap: "1rem",
                    alignItems: "center",
                    flexDirection: { xs: "column", lg: "row" },
                    justifyContent: { xs: "center", md: "flex-start" },
                    width: { xs: "100%", md: "25%" },
                  }}
                >
                  <Avatar
                    alt={listData.name}
                    src={"/Images/Outsourcing/expertImage.png"}
                    sx={{
                      background: commonCss.orange,
                      width: "50px",
                      height: "50px",
                    }}
                  />
                  <Typography sx={{ fontSize: "0.9rem" }}>
                    {listData.name}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "1rem",
                    width: { xs: "100%", md: "55%" },
                    alignItems: "center",
                    justifyContent: { xs: "center", md: "flex-start" },
                  }}
                >
                  {listData.expertList.map((expert, index) => (
                    <Typography
                      key={index}
                      variant="body1"
                      sx={{
                        fontSize: "0.9rem",
                        p: {
                          xs: "0.2rem 1rem",
                          md: "0.4rem 1rem",
                          width: "fit-content",
                          background: expert.bg,
                        },
                        borderRadius: "20px",
                      }}
                    >
                      {expert.title}
                    </Typography>
                  ))}
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    gap: { xs: "1rem", md: "0rem" },
                    alignItems: "center",
                    flexDirection: { xs: "column", lg: "row" },
                    justifyContent: { xs: "center", md: "flex-start" },
                    width: { xs: "45%", md: "7%" },
                  }}
                >
                  <Typography sx={{ fontSize: "0.9rem", fontWeight: 600 }}>
                    {listData.experience}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    gap: { xs: "1rem", md: "0rem" },
                    alignItems: "center",
                    flexDirection: { xs: "column", lg: "row" },
                    justifyContent: { xs: "center", md: "flex-start" },
                    width: { xs: "45%", md: "7%" },
                  }}
                >
                  {hire[listData.state] ? (
                    <Button
                      variant="outlined"
                      sx={{
                        color: commonCss.blue,
                        padding: "0.4rem 1rem",
                        textTransform: "none",
                        width: "fit-content",
                        fontWeight: 500,
                        fontSize: "0.9rem",
                        borderRadius: "30px",
                        ":hover": {
                          background: commonCss.blue,
                          color: commonCss.buttonText,
                        },
                      }}
                      onClick={() => {
                        navigate("/contactus");
                      }}
                    >
                      Recruit
                    </Button>
                  ) : (
                    <Typography sx={{ fontSize: "0.9rem", fontWeight: 600 }}>
                      <span style={{ filter: "blur(0.4rem" }}>$5</span> /h
                    </Typography>
                  )}
                </Box>
              </Box>
            </Grid2>
          ))}
          <Grid2 container size={12} justifyContent={"center"}>
            <Button
              variant="outlined"
              sx={{
                color: commonCss.blue,
                padding: "0.5rem 1rem",
                textTransform: "none",
                width: "fit-content",
                fontWeight: 500,
                fontSize: "0.95rem",
                borderRadius: "30px",
                ":hover": {
                  background: commonCss.blue,
                  color: commonCss.buttonText,
                },
                mt: "2rem",
              }}
              onClick={() => {
                navigate("/contactus");
              }}
            >
              Enhance Your Team with Experts
            </Button>
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2 container justifyContent={"center"} size={12} sx={{ padding: " 2rem 2rem 0rem 2rem" }}>
        <Grid2 size={12}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 550,
              textAlign: "center",
              mt: "1rem",
              mb: "0.5rem",
            }}
          >
            Quickly scale your team with the right experts
          </Typography>
        </Grid2>
        <Grid2
          container
          justifyContent={"center"}
          size={12}
          sx={{ maxWidth: { xs: "auto", xl: "2000px" } }}
        >
          {/* <AutoSlider /> */}
          <Box
            component={"img"}
            alt="flow chart"
            src={"/Images/Outsourcing/flowchart.png"}
            sx={{ maxWidth: "100%" }}
          />
        </Grid2>
      </Grid2>
      <Grid2 container justifyContent={"center"} alignItems={"center"} size={12}>
        <Grid2
          container
          alignItems={"center"}
          size={12}
          // spacing={{ xs: "1rem", md: "1rem" }}
          spacing={"1.5rem"}
          sx={{
            p: { xs: "1.5rem", md: "0rem 3rem 3rem 3rem" },
            maxWidth: { xs: "auto", xl: "2000px" },
          }}
        >
          <Grid2 size={12}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 550,
                textAlign: "center",
                mt: "1rem",
                mb: "0.5rem",
              }}
            >
              FAQs
            </Typography>
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: "1.1rem",
                color: commonCss.gray,
                textAlign: "center",
                mb: "2rem",
              }}
            >
              Most Asked Questions
            </Typography>
          </Grid2>
          {questionList.map((listQues, i) => (
            <Grid2 key={i} size={12}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "1rem",
                  width: "100%",
                  cursor: "pointer",
                  p: 0.5,
                  color: question[listQues.state] ? commonCss.blue : "black",
                  borderBottom: question[listQues.state]
                    ? `2px solid ${commonCss.blue}`
                    : "2px solid #d6d6d6",
                  ":hover": {
                    color: commonCss.blue,
                    borderBottom: `2px solid ${commonCss.blue}`,
                  },
                }}
                onClick={() => {
                  handleCollapseOpen(listQues.state, !question[listQues.state]);
                }}
              >
                <Typography sx={{ fontSize: "1.15rem", color: "inherit" }}>
                  {listQues.questionName}
                </Typography>
                <IconButton
                  size="small"
                  aria-hidden="true"
                  tabIndex={-1}
                  sx={{
                    color: "inherit",
                    p: 0.2,
                  }}
                >
                  {question[listQues.state] ? (
                    <RemoveCircle sx={{ fontSize: "1.4rem" }} />
                  ) : (
                    <AddCircleOutline sx={{ fontSize: "1.4rem" }} />
                  )}
                </IconButton>
              </Box>
              <Collapse in={question[listQues.state]}>
                <Box sx={{ p: "1rem" }}>
                  <Typography sx={{ fontSize: "1rem" }}>
                    {listQues.answer}
                  </Typography>
                  <Box
                    sx={{
                      mt: "1.5rem",
                      display: listQues.listOfAns ? "flex" : "none",
                      flexDirection: "column",
                      gap: "0.5rem",
                    }}
                  >
                    {listQues.anslist.map((dataList, i) => (
                      <Box
                        sx={{
                          display: "flex",
                          gap: "1rem",
                          alignItems: "flex-start",
                        }}
                      >
                        <Done />
                        <Typography sx={{ fontSize: "1rem" }}>
                          <span style={{ fontWeight: 600 }}>
                            {dataList.title}
                          </span>
                          {dataList.answer}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Collapse>
            </Grid2>
          ))}
          <Grid2 size={12}>
            <Typography variant="h6" sx={{ mt: "2rem" }}>
              We serve a wide range of industries. Don’t hesitate to
              reach out to us:{" "}
              <span style={{ color: commonCss.blue }}>
                jobs@solverthoughts.com
              </span>
            </Typography>
          </Grid2>
        </Grid2>
      </Grid2>
    </Grid2>
  );
};

export default Outsourcing;
